module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/massage-desktop@2x-d55ffb08f400d085c571398e7ae92f2c.jpg";